export default {
  banner: () => import("/app/layouts/banner.vue").then(m => m.default || m),
  "center-h": () => import("/app/layouts/center-h.vue").then(m => m.default || m),
  center: () => import("/app/layouts/center.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m)
}